import { render, staticRenderFns } from "./cart-wholesale.component.vue?vue&type=template&id=374ff3ff&scoped=true&"
import script from "./cart-wholesale.component.vue?vue&type=script&lang=js&"
export * from "./cart-wholesale.component.vue?vue&type=script&lang=js&"
import style0 from "./cart-wholesale.component.vue?vue&type=style&index=0&id=374ff3ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374ff3ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ksaffer/Projects/Client/natorp-plant-database/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('374ff3ff')) {
      api.createRecord('374ff3ff', component.options)
    } else {
      api.reload('374ff3ff', component.options)
    }
    module.hot.accept("./cart-wholesale.component.vue?vue&type=template&id=374ff3ff&scoped=true&", function () {
      api.rerender('374ff3ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "_src/js/components/cart-wholesale.component.vue"
export default component.exports